import { render } from "./createAccountant.vue?vue&type=template&id=d6e3c1c4"
import script from "./createAccountant.vue?vue&type=script&lang=js"
export * from "./createAccountant.vue?vue&type=script&lang=js"

import "./createAccountant.vue?vue&type=style&index=0&id=d6e3c1c4&lang=css"

import exportComponent from "/usr/src/old_admin_etchite_latest_prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__